export interface CostSheetInputs {
  areaSqft: number;
  baseRateSqft: number;
  plcCharges: number;
  parkingCharges: number;
  clubCharges: number;
  gstPercent: number;
  stampDutyPercent: number;
  registrationFee: number;
}

export interface CostSheetBreakdown {
  basicCost: number;
  totalPLC: number;
  parking: number;
  club: number;
  netAgreementValue: number;
  gstAmount: number;
  stampDutyAmount: number;
  reg: number;
  grandTotal: number;
}

/** Pure cost-sheet math — unit-tested; keep UI free of formula drift. */
export function calculateCostSheet(input: CostSheetInputs): CostSheetBreakdown {
  const area = Number(input.areaSqft) || 0;
  const rate = Number(input.baseRateSqft) || 0;
  const plc = Number(input.plcCharges) || 0;
  const parking = Number(input.parkingCharges) || 0;
  const club = Number(input.clubCharges) || 0;
  const gstRate = (Number(input.gstPercent) || 0) / 100;
  const stampRate = (Number(input.stampDutyPercent) || 0) / 100;
  const reg = Number(input.registrationFee) || 0;

  const basicCost = area * rate;
  const totalPLC = plc; // absolute PLC amount (UI enters total, not per-sqft)
  const netAgreementValue = basicCost + totalPLC + parking + club;
  const gstAmount = Math.round(netAgreementValue * gstRate);
  const stampDutyAmount = Math.round(netAgreementValue * stampRate);
  const grandTotal = netAgreementValue + gstAmount + stampDutyAmount + reg;

  return {
    basicCost,
    totalPLC,
    parking,
    club,
    netAgreementValue,
    gstAmount,
    stampDutyAmount,
    reg,
    grandTotal,
  };
}
